import HttpClient from '../../../core/HttpClient';
import Failure from '../../../core/Failure';
import { Authentication } from '@leedpulse-monorepo/classes';

export interface LeedbucksConfig {
  unit_value: number;
  actions: Record<string, { unit_value: number }>;
  subscriptions?: Record<string, Record<string, { unit_value: number }>>; // the valid rates of each subscription of the company
}

export interface LeedbucksConfigScope {
  subscriptionId?: string; // that subscription's valid rates, in the global shape
  allSubscriptions?: boolean; // every subscription's next to the global ones, what the overview sums
}

// Neither: the global rates only, what the plan cards show
export async function getLeedbucksConfig(
  companyApiKey: string,
  auth: Authentication,
  scope: LeedbucksConfigScope = {},
): Promise<LeedbucksConfig> {
  try {
    const query = scope.subscriptionId
      ? `?subscription_id=${encodeURIComponent(scope.subscriptionId)}`
      : (scope.allSubscriptions ? '?subscriptions=all' : '');
    const response = await HttpClient.get(`/leedflow/credits-metadata${query}`, auth.token, {
      'x-api-key': companyApiKey,
    });

    return (response?.data ?? { unit_value: 0, actions: {} }) as LeedbucksConfig;
  } catch (e) {
    console.error('getLeedbucksConfig error:', e);
    throw new GetLeedbucksConfigFailure((e as Error)?.message || 'Unknown error');
  }
}

export class GetLeedbucksConfigFailure extends Failure {
  constructor(message = 'Unknown error', code = 'get-leedbucks-config-failure') {
    super(message, code);
  }
}
